module.exports = __webpack_public_path__ + "static/media/a1.ede08aa5.jpg";